import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const CustomButton = styled(ButtonMui)`
    width: 13rem !important;    
    height: 3.5rem !important;
    margin: 0 !important;
    margin-top: 6rem !important;
`
